module.exports = __webpack_public_path__ + "img/icon_todo.00bfd349.png";